export const setRemoteControlSession = (session, reason = null) => ({
  type: "SET_REMOTE_CONTROL_SESSION",
  payload: { session, reason },
});

export const clearRemoteControl = () => ({
  type: "CLEAR_REMOTE_CONTROL",
});
